<script lang="ts">
// import HelloWorld from './components/HelloWorld.vue'
import { RouterView } from "vue-router";
import { defineComponent } from "vue";
import { ElConfigProvider } from "element-plus";
import Banner from "@/components/Banner/index.vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
export default defineComponent({
  components: {
    ElConfigProvider,
    Banner
  },
  setup() {
    return {
      locale: zhCn, 
    };
  },
});
</script>

<template>

  
  <el-config-provider :locale="locale">
  
    <router-view></router-view>
    
  </el-config-provider>

  <!-- <div>

    <a href="https://vitejs.dev" target="_blank">
      <img src="/vite.svg" class="logo" alt="Vite logo" />
    </a>
    <a href="https://vuejs.org/" target="_blank">
      <img src="./assets/vue.svg" class="logo vue" alt="Vue logo" />
    </a>
  </div>
  <HelloWorld msg="Vite + Vue" />
   -->
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}

</style>
